import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@umss/shared/data-access';

export const facilityGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const ids = auth.authState().facilityIds ?? [];

  if (ids.length > 0) return true;

  router.navigateByUrl('/select-facility');

  return false;
};
